// report_builder/reportApi.js
// ============================================================
// ALL API CALLS FOR REPORT BUILDER
// Uses the same axios instance (api) from src/api.js
// which already handles JWT token attachment automatically.
//
// Functions:
//   fetchRegistry()              — variable + operator registry
//   fetchReports()               — list all saved reports
//   fetchReport(id)              — single report with definition
//   createReport(data)           — save new report
//   updateReport(id, data)       — update existing report
//   deleteReport(id)             — soft delete report
//   runReport(params)            — execute report, get results
//   fetchWatchlistsForReport()   — watchlists for scope picker
// ============================================================

import { api } from '../api';

const BASE = '/report-builder';


// ============================================================
// REGISTRY
// ============================================================

export const fetchRegistry = async () => {
  const res = await api.get(`${BASE}/registry`);
  return res.data;
};


// ============================================================
// REPORT DEFINITION CRUD
// ============================================================

export const fetchReports = async () => {
  const res = await api.get(`${BASE}/reports`);
  return res.data;
};

export const fetchReport = async (reportId) => {
  const res = await api.get(`${BASE}/reports/${reportId}`);
  return res.data;
};

export const createReport = async ({
  name,
  description,
  base_timeframe,
  definition,
}) => {
  const res = await api.post(`${BASE}/reports`, {
    name,
    description,
    base_timeframe,
    definition,
  });
  return res.data;
};

export const updateReport = async (reportId, {
  name,
  description,
  base_timeframe,
  definition,
}) => {
  const res = await api.put(`${BASE}/reports/${reportId}`, {
    name,
    description,
    base_timeframe,
    definition,
  });
  return res.data;
};

export const deleteReport = async (reportId) => {
  const res = await api.delete(`${BASE}/reports/${reportId}`);
  return res.data;
};


// ============================================================
// RUN REPORT
// ============================================================

export const runReport = async ({
  report_id,
  scope_type,
  scope_value,
  from_date,
  to_date,
  base_timeframe,
}) => {
  const res = await api.post(`${BASE}/run`, {
    report_id,
    scope_type,
    scope_value,
    from_date,
    to_date,
    base_timeframe,
  }, { timeout: 120000 });
  return res.data;
};


// ============================================================
// WATCHLISTS FOR SCOPE PICKER
// ============================================================

export const fetchWatchlistsForReport = async () => {
  const res = await api.get(`${BASE}/watchlists`);
  return res.data;
};


// ============================================================
// LIVE SCANNER (R6)
// ============================================================

export const setReportLive = async (reportId, {
  live_enabled,
  live_watchlist_id,
}) => {
  const res = await api.put(`${BASE}/reports/${reportId}/live`, {
    live_enabled,
    live_watchlist_id,
  });
  return res.data;
};

export const fetchReportAlertsToday = async () => {
  const res = await api.get(`${BASE}/alerts/today`);
  return res.data;
};


// ============================================================
// WORKFLOW POLISH (R7)
// ============================================================

export const validateReport = async (params) => {
  const res = await api.post(`${BASE}/validate`, params,
                             { timeout: 60000 });
  return res.data;
};

export const duplicateReport = async (reportId) => {
  const res = await api.post(`${BASE}/reports/${reportId}/duplicate`);
  return res.data;
};

export const fetchReportRuns = async (reportId) => {
  const res = await api.get(`${BASE}/reports/${reportId}/runs`);
  return res.data;
};

export const inspectMatch = async ({
  report_id, symbol, bucket, base_timeframe,
}) => {
  const res = await api.post(`${BASE}/inspect`, {
    report_id, symbol, bucket, base_timeframe,
  }, { timeout: 60000 });
  return res.data;
};